import PreviewProductListComponent from './index.vue';
var previewProductListFrom = {};
previewProductListFrom.install = function (Vue, options) {
  var ComponentConstructor = Vue.extend(PreviewProductListComponent);
  // 生成一个该子类的实例
  var instance = new ComponentConstructor();
  instance.$mount(document.createElement('div'));
  document.body.appendChild(instance.$el);
  Vue.prototype.$modalPreviewProductList = function (callback) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$multiple = options.multiple,
      multiple = _options$multiple === void 0 ? false : _options$multiple,
      _options$limit = options.limit,
      limit = _options$limit === void 0 ? 100 : _options$limit,
      _options$isDefault = options.isDefault,
      isDefault = _options$isDefault === void 0 ? true : _options$isDefault,
      _options$valueKey = options.valueKey,
      valueKey = _options$valueKey === void 0 ? 'id' : _options$valueKey,
      _options$checked = options.checked,
      checked = _options$checked === void 0 ? [] : _options$checked;
    instance.visible = true;
    instance.callback = callback;
    instance.multiple = multiple;
    instance.limit = limit;
    instance.isDefault = isDefault;
    instance.checked = checked;
    instance.valueKey = valueKey;
  };
};
export default previewProductListFrom;